import {  HttpClient, HttpErrorResponse, HttpHeaders, } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AdminResource } from '../models/resource-model';
import { AppConfig } from "../design/app";
import { IAppConfig } from '../core/models/app-config.model';
import { IApiResponse } from '../core/models/api-response.model';

const urlsStartPoint = '';



@Injectable({
    providedIn: 'root'
})

export class ResourcesService {
    public appConfig:any;

  constructor(private http: HttpClient) {
    this.appConfig = AppConfig;
     }

    public getResourcesData(onlyActive): Observable<any> {
    const baseUrl = this.appConfig.resources.baseUrl;
    const getResources = this.appConfig.resources.getResources;
    const url = `${baseUrl + getResources + '?onlyActive=' + onlyActive}`;
    return this.http.get<IApiResponse<AdminResource>>(url).pipe(map(res=>{
        return res.Data;
    }));
    }

    public updateSortOrder(resources: AdminResource[]):Observable<string> {
        const baseUrl = this.appConfig.resources.baseUrl;
        const updateSortOrder = this.appConfig.resources.updateSortOrder;
        const url = `${baseUrl + updateSortOrder}`;
        return this.http.post<IApiResponse<string>>(url,resources ).pipe(
                map(response => {
                    return response.Message
                }),
                catchError(this.handleError)
            );
    }

    public addEditRemoveData(adminResource:AdminResource,isDelete) {      
        const baseUrl = this.appConfig.resources.baseUrl;
        const addResource = this.appConfig.resources.addResource;
        const headers = new HttpHeaders();
        const url = `${baseUrl + addResource + '?isDelete=' + isDelete}`;
        return this.http.post<IApiResponse<string>>(url,adminResource,{headers:headers}).pipe(
                map(response => {
                    return response.Message
                }),
                catchError(this.handleError)
            );

    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        return throwError(
            'Something bad happened; please try again later.');
    };
}
